(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about_hero"] && !Shopify.designMode) return;
  try {
    
/* Generic scroll-fade observer moved to assets/scroll-fade.js (site-wide). Below: hero-only char-split title animation. */
(function() {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function splitTextIntoChars(element, startDelay, perCharDelay) {
    if (!element) return;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) { textNodes.push(node); }

    var charIndex = 0;
    textNodes.forEach(function(textNode) {
      var text = textNode.textContent;
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < text.length; i++) {
        var ch = text.charAt(i);
        if (ch === ' ' || ch === '\n' || ch === '\t') {
          fragment.appendChild(document.createTextNode(ch));
        } else {
          var span = document.createElement('span');
          span.className = 'about-hero-char';
          span.textContent = ch;
          span.style.animationDelay = (startDelay + charIndex * perCharDelay) + 'ms';
          fragment.appendChild(span);
          charIndex++;
        }
      }
      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function countAnimChars(element) {
    if (!element) return 0;
    return (element.textContent || '').replace(/\s/g, '').length;
  }

  function run() {
    var h1 = document.querySelector('.about-hero .heading-style-h1');
    var para = document.querySelector('.about-hero .about-hero-subTitle');

    var startDelay = 75;
    var charFadeDuration = 175;
    var h1Stagger = 9;

    var h1Count = countAnimChars(h1);
    var paraCount = countAnimChars(para);
    var h1FinishMs = startDelay + Math.max(0, h1Count - 1) * h1Stagger + charFadeDuration;

    if (h1) splitTextIntoChars(h1, startDelay, h1Stagger);
    if (para) {
      // Stagger sized so paragraph completes at the same instant as the H1
      var paraStagger = paraCount > 1 ? (h1FinishMs - startDelay - charFadeDuration) / (paraCount - 1) : 0;
      splitTextIntoChars(para, startDelay, paraStagger);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about_proof"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (typeof window === 'undefined') return;
  var rotators = document.querySelectorAll('[data-rotator]');
  if (!rotators.length) return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  if (!isDesktop) return;

  rotators.forEach(function(rotator) {
    var allCells = Array.from(rotator.querySelectorAll('.about-proof_logo-cell'));
    var visibleCells = allCells.filter(function(c) { return !c.classList.contains('is-pooled'); });
    var pooledCells = allCells.filter(function(c) { return c.classList.contains('is-pooled'); });

    if (pooledCells.length === 0) return;

    var queue = pooledCells.map(function(c) {
      return { name: c.dataset.cellName, logo: c.dataset.cellLogo, logoUrl: c.dataset.cellLogoUrl || '' };
    });

    var isPaused = false;
    var lastSwapIndex = -1;
    var inFlight = {};
    rotator.addEventListener('mouseenter', function() { isPaused = true; });
    rotator.addEventListener('mouseleave', function() { isPaused = false; });

    function swapCell() {
      if (isPaused || queue.length === 0) return;

      // Pick a random visible cell, excluding the last-swapped and any mid-fade
      var availableIndices = [];
      for (var i = 0; i < visibleCells.length; i++) {
        if (i !== lastSwapIndex && !inFlight[i]) availableIndices.push(i);
      }
      if (availableIndices.length === 0) return;
      var cellIndex = availableIndices[Math.floor(Math.random() * availableIndices.length)];
      lastSwapIndex = cellIndex;
      inFlight[cellIndex] = true;
      var cell = visibleCells[cellIndex];

      var oldContent = cell.querySelector('.about-proof_logo-content');
      if (!oldContent) { delete inFlight[cellIndex]; return; }

      var nextData = queue.shift();
      var currentData = { name: cell.dataset.cellName, logo: cell.dataset.cellLogo, logoUrl: cell.dataset.cellLogoUrl || '' };
      queue.push(currentData);

      cell.dataset.cellName = nextData.name;
      cell.dataset.cellLogo = nextData.logo;
      cell.dataset.cellLogoUrl = nextData.logoUrl;

      var newContent = document.createElement('div');
      newContent.className = 'about-proof_logo-content';
      newContent.style.opacity = '0';

      if (nextData.logo && nextData.logo.length > 0 && nextData.logoUrl) {
        var newImg = document.createElement('img');
        newImg.className = 'about-proof_logo';
        newImg.alt = nextData.name;
        newImg.src = nextData.logoUrl;
        newImg.loading = 'lazy';
        newContent.appendChild(newImg);
      } else {
        var newPlaceholder = document.createElement('div');
        newPlaceholder.className = 'about-proof_placeholder';
        newPlaceholder.textContent = nextData.name;
        newContent.appendChild(newPlaceholder);
      }

      cell.appendChild(newContent);
      // Force reflow so the opacity transition triggers
      void newContent.offsetWidth;

      newContent.style.opacity = '1';
      oldContent.style.opacity = '0';

      setTimeout(function() {
        if (oldContent.parentNode) oldContent.parentNode.removeChild(oldContent);
        delete inFlight[cellIndex];
      }, 1100);
    }

    var initialDelay = 1500;
    setTimeout(function() {
      setInterval(swapCell, 1500);
    }, initialDelay);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
